import { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { Menu, X } from "lucide-react";
import { Brand } from "./Brand";

const LINKS = [
  { label: "Productos", href: "#productos", id: "productos" },
  { label: "Por qué TUPU", href: "#por-que-tupu", id: "por-que-tupu" },
  { label: "Contacto", href: "#contacto", id: "contacto" },
];

export const Header = () => {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-header"
      className={`fixed inset-x-0 top-0 z-50 border-b backdrop-blur-xl transition-[background-color,border-color,box-shadow] duration-300 ${
        scrolled
          ? "border-[#1F3D35]/10 bg-[#F8F8F3]/85 shadow-[0_8px_32px_rgba(31,61,53,0.06)]"
          : "border-transparent bg-[#F8F8F3]/60"
      }`}
    >
      <div className="mx-auto flex h-[72px] max-w-7xl items-center justify-between px-6 md:px-12">
        <a href="#" data-testid="header-logo-link" aria-label="TUPU inicio" onClick={(e) => { e.preventDefault(); window.scrollTo({ top: 0, behavior: "smooth" }); }}>
          <Brand />
        </a>

        <nav className="hidden items-center gap-9 md:flex" aria-label="Principal">
          {LINKS.map((link) => (
            <a
              key={link.id}
              href={link.href}
              data-testid={`nav-${link.id}`}
              className="text-sm font-medium tracking-wide text-[#1F3D35]/70 transition-colors hover:text-[#0F4D3F]"
            >
              {link.label}
            </a>
          ))}
        </nav>

        <div className="hidden items-center gap-3 md:flex">
          <a
            href="#"
            data-testid="header-login-button"
            className="rounded-full border border-[#1F3D35]/20 px-5 py-2.5 text-sm font-medium text-[#1F3D35] transition-colors hover:bg-[#F3EBD7]"
          >
            Ingresar
          </a>
          <a
            href="#productos"
            data-testid="header-cta-button"
            className="rounded-full bg-[#C6F04A] px-5 py-2.5 text-sm font-semibold text-[#1F3D35] transition-[background-color,transform] duration-200 hover:bg-[#b5e039] active:scale-[0.98]"
          >
            Ver soluciones
          </a>
        </div>

        <button
          data-testid="mobile-menu-button"
          className="flex h-11 w-11 items-center justify-center rounded-full border border-[#1F3D35]/15 text-[#1F3D35] md:hidden"
          onClick={() => setOpen((v) => !v)}
          aria-label={open ? "Cerrar menú" : "Abrir menú"}
          aria-expanded={open}
        >
          {open ? <X size={20} /> : <Menu size={20} />}
        </button>
      </div>

      <AnimatePresence>
        {open && (
          <motion.div
            data-testid="mobile-menu"
            initial={{ opacity: 0, height: 0 }}
            animate={{ opacity: 1, height: "auto" }}
            exit={{ opacity: 0, height: 0 }}
            transition={{ duration: 0.28, ease: [0.22, 1, 0.36, 1] }}
            className="overflow-hidden border-t border-[#1F3D35]/10 bg-[#F8F8F3]/95 backdrop-blur-xl md:hidden"
          >
            <div className="flex flex-col gap-1 px-6 py-5">
              {LINKS.map((link) => (
                <a
                  key={link.id}
                  href={link.href}
                  data-testid={`mobile-nav-${link.id}`}
                  onClick={() => setOpen(false)}
                  className="rounded-xl px-4 py-3 text-base font-medium text-[#1F3D35] transition-colors hover:bg-[#F3EBD7]"
                >
                  {link.label}
                </a>
              ))}
              <div className="mt-3 flex gap-3 px-4">
                <a
                  href="#"
                  data-testid="mobile-login-button"
                  className="flex-1 rounded-full border border-[#1F3D35]/20 px-5 py-3 text-center text-sm font-medium text-[#1F3D35]"
                >
                  Ingresar
                </a>
                <a
                  href="#productos"
                  data-testid="mobile-cta-button"
                  onClick={() => setOpen(false)}
                  className="flex-1 rounded-full bg-[#C6F04A] px-5 py-3 text-center text-sm font-semibold text-[#1F3D35]"
                >
                  Ver soluciones
                </a>
              </div>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </header>
  );
};
